import api from './api';
import { ApiResponse, Lead, LeadStats } from '../types';

export interface LeadFilters { status?: string; temperature?: string; source?: string; search?: string; assignedTo?:string; followUpFrom?:string; followUpTo?:string; archived?:boolean; }
export interface CreateLeadDto {
  name: string; mobile: string; email?: string;
  source?: string; temperature?: string; status?: string;
  service?: string; notes?: string; followUpDate?: string;
  assignedTo?: string;
  servicesInterested?: string[];
}

const leadsService = {
  getStats:  ()                             => api.get<ApiResponse<LeadStats>>('/leads/stats').then(r => r.data),
  getAll:    (f: LeadFilters = {})          => api.get<ApiResponse<Lead[]>>('/leads', { params: f }).then(r => r.data),
  create:    (data: CreateLeadDto)          => api.post<ApiResponse<Lead>>('/leads', data).then(r => r.data),
  update:    (id: string, data: Partial<CreateLeadDto>) => api.put<ApiResponse<Lead>>(`/leads/${id}`, data).then(r => r.data),
  delete:    (id: string)                   => api.delete<ApiResponse>(`/leads/${id}`).then(r => r.data),
  convert:   (id: string)                   => api.post<ApiResponse<{ lead: Lead; client: unknown }>>(`/leads/${id}/convert`).then(r => r.data),
  addFollowUp: (id:string,data:{note:string;nextFollowUpDate?:string})=>api.post<ApiResponse<Lead>>(`/leads/${id}/followups`,data).then(r=>r.data),
  assign: (id:string,assignedTo:string)=>api.patch<ApiResponse<Lead>>(`/leads/${id}/assign`,{assignedTo}).then(r=>r.data),
  archive: (id:string,archived=true)=>api.patch<ApiResponse<Lead>>(`/leads/${id}/archive`,{archived}).then(r=>r.data),
  importLeads: (leads:Partial<CreateLeadDto>[])=>api.post<ApiResponse<Lead[]>>('/leads/import',{leads}).then(r=>r.data),
  exportCsv: ()=>api.get('/leads/export/csv',{responseType:'blob'}),
};

export default leadsService;
